const headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

export function trackPageView(pageName: string): void {
    fetch('/Telemetry/TrackPageView', {
        method: 'POST',
        headers,
        body: JSON.stringify({ pageName }),
    }).catch(() => { /* fire-and-forget */ });
}

export function trackEvent(eventName: string, properties?: Record<string, string>): void {
    fetch('/Telemetry/TrackEvent', {
        method: 'POST',
        headers,
        body: JSON.stringify({ eventName, properties }),
    }).catch(() => { /* fire-and-forget */ });
}

export function trackError(message: string, sourceId: string, context?: string): void {
    fetch('/Telemetry/TrackError', {
        method: 'POST',
        headers,
        body: JSON.stringify({ message, sourceId, context }),
    }).catch(() => { /* fire-and-forget */ });
}
